import { useLazyQuery } from "@apollo/client";
import { GET_NETWORK_SELECTOR_ITEMS } from "../../graphql/queries/CompanyAdminContext";

// eslint-disable-next-line import/prefer-default-export
export const useGetNetworkSelectorItems = ({ companyId = null } = {}) => {
  const [getItems, { data, loading, error }] = useLazyQuery(
    GET_NETWORK_SELECTOR_ITEMS,
    {
      variables: {
        companyId,
      },
    }
  );

  const networkSelectorItems =
    data?.companyAdminContext?.companyNetworks?.networkSelectorItems ?? [];

  return {
    getNetworkSelectorItems: getItems,
    networkSelectorItems,
    data,
    loading,
    error,
  };
};
